import {
  ButtonGroup,
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export function SecondaryInfoModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          textStyle="global/body-secondary"
          textColor="text-weak"
          testID="npc-identification-documents-secondary-document-whats-this-button"
        >
          <Trans>What's this?</Trans>
        </Link>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("Secondary document")} />
          <ModalContent>
            <Text style="global/body-primary">
              <Trans>The following secondary documents are accepted:</Trans>
            </Text>
            <br />
            <br />
            <List type="unordered">
              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Department of Veterans Affairs (DVA) card
                  </strong>{" "}
                  - name and address required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Centrelink card (with reference number)
                  </strong>{" "}
                  - name and address required - 40 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Birth Certificate Extract
                  </strong>{" "}
                  - name is required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Birth card (NSW Births, Deaths, Marriages issue only)
                  </strong>{" "}
                  - name is required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Medicare card
                  </strong>{" "}
                  - name required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Credit card or account card
                  </strong>{" "}
                  - name required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Marriage certificate (Australian Registry issue
                    only)
                  </strong>{" "}
                  - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Marriage Certificate
                  </strong>{" "}
                  - name and signature required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Decree Nisi / Decree Absolute (Australian Registry issue
                    only)
                  </strong>{" "}
                  - name and signature required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Change of name certificate (Australian Registry issue only)
                  </strong>{" "}
                  - name and signature required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Bank statement (showing transactions)
                  </strong>{" "}
                  - name and address required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Property lease agreement (current address)
                  </strong>{" "}
                  - name and address required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Taxation assessment notice
                  </strong>{" "}
                  - name and address required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Australian Mortgage Documents (Current address)
                  </strong>{" "}
                  - name and address required - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Rating Authority
                  </strong>{" "}
                  - Current address eg Land Rates - 25 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Utility Bill (electricity, gas, telephone)
                  </strong>{" "}
                  - Name and current address less than 12 months old - 20 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Reference from Indigenous Organisation
                  </strong>{" "}
                  - name and photo required - 20 points
                </Trans>
              </ListItem>

              <ListItem>
                <Trans>
                  <strong
                    className={css({
                      fontWeight: weights["font-weight-medium"],
                    })}
                  >
                    Documents issued outside Australia (equivalent to Australian
                    documents).
                  </strong>{" "}
                  Must have official translation attached - name and photo
                  required - 20 points
                </Trans>
              </ListItem>
            </List>
          </ModalContent>
          <ModalFooter>
            <ButtonGroup>
              <PrimaryButton onPress={close} size="medium">
                <Trans>Okay</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
